// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseWelcomeAdminPanelAreaRoutes = {
  route: '/welcome-admin-panel',
}

export const WelcomeAdminPanelAreaRoutes = transformRoutes(
  BaseWelcomeAdminPanelAreaRoutes,
)
